import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { propFunc, propShape, } from '../../../../../../helpers/custom-prop-types';
import { isReviewedClient } from '../../../../../../helpers/solution';
const RowActionReview = (props) => {
    const { item, onClickReview, review } = props;
    // review.
    const isReviewed = isReviewedClient(item);
    const valuation = _.get(review, 'valuation');
    const setStyle = {
        1: '20%',
        2: '40%',
        3: '60%',
        4: '80%',
        5: '100%',
    };
    return (_jsxs("div", Object.assign({ className: 'review' }, { children: [_jsxs("div", Object.assign({ className: 'review-star' }, { children: [_jsx("div", Object.assign({ className: 'star-rating-front', style: { width: setStyle[valuation] || '0%' } }, { children: "\u2605\u2605\u2605\u2605\u2605" })), _jsx("div", Object.assign({ className: 'star-rating-back' }, { children: "\u2605\u2605\u2605\u2605\u2605" }))] })), _jsx("button", Object.assign({ className: 'btn btn-secondary small modalBtn', onClick: onClickReview, type: 'button' }, { children: isReviewed ? 'レビューを見る' : 'レビュー' }))] })));
};
RowActionReview.propTypes = {
    item: propShape().isRequired,
    onClickReview: propFunc().isRequired,
    review: propShape().isRequired,
};
export default RowActionReview;
